export enum AboType {    
    O = 1,
    A = 2,
    B = 3,
    Ab = 4,
    Unknown = 5
}